<template>
  <div>
    <b-row align-h="between" align-v="center">
      <b-col cols="12" md="auto" >
        <h3 class="tabheading">{{$t('audits.suspiciousfiles.title')}}</h3>
        <h4 class="tabheading__subline text--right">{{$t('audits.title')}} {{ date }}</h4>
      </b-col>
      <b-col cols="12" md="auto" >
        <div class="actions">
          <button v-on:click="includeIgnored = !includeIgnored" class="btn btn--primary btn-sm">
            {{$t('audits.suspiciousfiles.togglefiles')}}
          </button>
        </div>
      </b-col>
    </b-row>
    <hr/>
    <table class="table table--overview table--collapsable" v-if="filteredFiles.length">
      <tbody>
      <tr
        v-for="(file, key) in filteredFiles"
        v-bind:key="key"
      >
        <td class="ignorecolumn align-text-top">
          <button v-b-tooltip.top="$t('audits.suspiciousfiles.ignorefile')" class="btn" @click="toggleIgnore(file.file)" :class="getIgnoreButtonClass(file)">
            <img src="/images/icon/siteinformation/icon_ignore.svg"/>
          </button>
        </td>
        <td>
          <span v-b-toggle="`audit-suspiciousfile-${key}`" class="td-collapsable__title td-collapsable__title--warning">{{ file.file }}<span class="td-collapsable__title__subtitle">{{ $t('audits.suspiciousfiles.finding') }}: {{file.match}} {{ $t('audits.suspiciousfiles.inline') }} {{file.line}}</span></span>
          <b-collapse :id="`audit-suspiciousfile-${key}`" class="td-collapsable__content site-audit__code">
            <template slot-scope="collapseable">
              <pre v-highlightjs="{ code: decodeFile(file.content), line: file.line }" v-if="collapseable.visible" :ref="`codeblock${key}`"><code></code></pre>
            </template>
          </b-collapse>
        </td>
        <td class="text-right align-text-top">
          <button v-b-toggle="`audit-suspiciousfile-${key}`" class="collapsable__toggle">
            <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.316406 1.28247L6.80599 8.61672C6.83336 8.64766 6.86699 8.67243 6.90465 8.6894C6.94231 8.70636 6.98314 8.71514 7.02445 8.71514C7.06575 8.71514 7.10659 8.70636 7.14425 8.6894C7.18191 8.67243 7.21554 8.64766 7.24291 8.61672L13.7331 1.28247" stroke="#919191" stroke-width="0.583333" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span class="visuallyhidden">$t('audits.suspiciousfiles.viewcode')</span>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
    <div class="well" v-else>
      <div class="contentcontainer contentcontainer--success">
        <b-container>
          <b-row align-v="center">
            <b-col sm="3" lg="2" xl="1">
              <img src="/images/icon/sitedetail/dashboard/general-success.svg"/>
            </b-col>
            <b-col sm="9" lg="10" xl="11">
              <p v-html="$t('audits.suspiciousfiles.allpassed')"></p>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'

export default {
  name: 'AuditSuspiciousFiles',

  props: [
    'id',
    'files',
    'site_id',
    'ignoredfiles',
    'date'
  ],

  data () {
    return {
      includeIgnored: false
    }
  },

  computed: {
    flaggedFiles () {
      if (!this.files) {
        return []
      }

      return this.files.map((file) => {
        file.ignored = (this.ignoredfiles.indexOf(file.file) !== -1)

        return file
      })
    },

    filteredFiles () {
      if (this.includeIgnored) {
        return this.flaggedFiles
      }

      return this.flaggedFiles.filter(file => !file.ignored)
    }
  },

  methods: {
    ...mapActions('site', [
      'toggleFileIgnore'
    ]),

    ...mapMutations('common', [
      'startLoading',
      'endLoading'
    ]),

    getFilename (path) {
      return path.split('\\').pop().split('/').pop()
    },

    async toggleIgnore (path) {
      this.startLoading()

      await this.toggleFileIgnore({ id: this.site_id, path: path })

      this.endLoading()
    },

    decodeFile (content) {
      return atob(content)
    },

    getIgnoreButtonClass (file) {
      return (file.ignored) ? 'btn--ghost' : 'btn--failed--link'
    }
  }
}
</script>
